import React from "react";
import Pricing from "@/components/Pricing";
import PageCTA from "@/components/PageCTA";

const PricingPage = () => (
  <div className="pt-24">
    <Pricing />
    <PageCTA
      heading="Still unsure which tier fits you?"
      sub="The Friction Audit answers that automatically — match to an engine, get your friction score, and we recommend a tier based on your inputs."
      secondary={{ to: "/engines", label: "Explore the Engines" }}
    />
  </div>
);

export default PricingPage;
